module.exports = __webpack_public_path__ + "static/whaleSightingsMap-13cbbeda9abeb2e305d9983b7656273b.png";